/// <reference path="../Page/PageManager.js" />
var windowResizeDelay;
var _controlSizeUpdateQueued = false;
// listeners for when the controls sizes gets updated
var ControlSizeListeners = new Array();
function _setToResizeControls(delay) {
  if (windowResizeDelay) {
    clearTimeout(windowResizeDelay);
  }
  _controlSizeUpdateQueued = true;
  windowResizeDelay = setTimeout(function updateControlSizeDelay() {
    updateControlSize(true, _currentViewId);
  }, delay);
}
function calcControlX(ctrl, bEscapeFromHtc) {
  return $(ctrl).position().left;
}
function calcControlY(ctrl, bEscapeFromHtc) {
  return $(ctrl).position().top;
}
// Returns the position of the element relative to another element.  The elements does not have
// to be contained.
// Return value is an object with X and Y properties.
function calcPixelPosition(el, relativeTo) {
  var elPosition = calcAbsolutePixelPosition(el);
  if (relativeTo) {
    var relativeToPosition = calcAbsolutePixelPosition(relativeTo);
    elPosition.X -= relativeToPosition.X;
    elPosition.Y -= relativeToPosition.Y;
  }
  return elPosition;
}
// Returns the position within the view corresponding to the location of the
// given element.
// Return value is an object with X and Y properties.
function calcViewPixelPosition(el, doc) {
  if (doc == undefined) doc = GetViewDocument(_currentViewId);
  var elPosition = calcAbsolutePixelPosition(el);
  var docPosition = calcAbsolutePixelPosition(document.documentElement);
  var retval = {
    X: elPosition.X - docPosition.X,
    Y: elPosition.Y - docPosition.Y
  };
  return retval;
}
// Returns the absolute position within the browser window corresponding to the location of the
// given element.
// Return value is an object with X and Y properties.
function calcAbsolutePixelPosition(el) {
  var retval = {};
  var offset = $(el).offset();
  retval.X = offset.left;
  retval.Y = offset.top;
  return retval;
}
var _updateSiblingsTimers = new Array();
//////////////////////////////////POSITION GROUPBOXES, GRIDS, and ATTACHMENTS FROM COLLAPSE OR EXPAND EVENT	//////////////////////////
//update group controls
//called when group control experiences a collapse or expand event
//node = Hansen control firing the event
//expand = Whether the control is expanding or collapsing
//conts = array of controls if manually defined
function updateSiblingGroupControls(node, expand, conts) {
  var parent = node.parentElement;
  // don't update IF the node is not visible.  Trying to get width/height and top/left values of a hidden node is never correct
  var isVisible = $(node).is(":visible");
  if (!isVisible) {
    //queue the parent to stack later if needed
    $(node).attr("updateSiblingQueued", true);
    return;
  } else if ($(node).attr("updateSiblingQueued") != undefined) {
    $(node).removeAttr("updateSiblingQueued");
  }
  if (_updateSiblingsTimers[parent] != null) {
    clearTimeout(_updateSiblingsTimers[parent]);
  }
  //This is to fix the delayed animation used in inforControlsCombined .SlideUp() to prevent the overlapping of controls.
  var delayCount = 0;
  for (var x = 0; x < node.children.length; x++) {
    var childNode = node.children[x];
    if (childNode != null) {
      var origClassName = node.children[x].className;
      var newClassName = origClassName.replace(/\s{2,}/g, " ");
      if (
        newClassName == "inforExpandButton closed" ||
        newClassName == "inforExpandButton hover closed"
      ) {
        delayCount = 500;
        break;
      }
    }
  }
  _updateSiblingsTimers[parent] = setTimeout(function() {
    updateSiblingGroupControlsDelayed(parent, expand, conts);
  }, delayCount);
}
//////////////////////////////////POSITION GROUPBOXES, GRIDS, and ATTACHMENTS FROM COLLAPSE OR EXPAND EVENT	//////////////////////////
//update group controls
//called when group control experiences a collapse or expand event
//node = Hansen control firing the event
//expand = Whether the control is expanding or collapsing
//conts = array of controls if manually defined
function updateSiblingGroupControlsDelayed(parent, expand, conts) {
  var j = 0;
  delete _updateSiblingsTimers[parent];
  //get all appropriate elements if control list wasn't predefined by caller
  if (conts == undefined) {
    conts = new Array();
    for (var i = 0; i < parent.children.length; i++) {
      var child = parent.children[i];
      if (child.tagName) {
        child.dontStack = false;
        if (!$(child).is(":visible")) {
          conts[j] = child;
          conts[j].dontStack = true;
          j++;
          continue;
        }
        if (child.getAttribute("isUCC") || child.getAttribute("isTabPane")) {
          var $expandButton = $(child).find(".inforExpandButton");					
		  if ($expandButton.length > 0) {
			if ($(child).height() === 0 && !expand) {
				$(child).height(child.scrollHeight);
			} else if (expand === false) {
				$(child).height(0);
		  }
		}
		else
		{
			if ($(child).height() === 0)
				$(child).height(child.scrollHeight);
		}
          conts[j] = child;
          j++;
        } else if (
          child.getAttribute("isGroupBoxOuter") ||
          child.getAttribute("isGrid") ||
          child.getAttribute("isAttachments")
        ) {
          conts[j] = child;
          if ($(child).hasClass("ipsProxyControl") === true) {
            conts[j].dontStack = true;
          }
          j++;
        }
        if (
          child.getAttribute("isLabel") ||
          child.getAttribute("isAssetControl") ||
          child.getAttribute("isEditBox") ||
          child.getAttribute("isDropDown") ||
          child.getAttribute("isCheckbox") ||
          child.getAttribute("IsHTMLArea") ||
          child.getAttribute("isFileUpload")
        ) {
          if (child.outerTag) {
            conts[j] = child.outerTag;
          } else {
            conts[j] = child;
          }
          conts[j].dontStack = true;
          j++;
        }
      }
    }
  }
  //sort the array by current top position
  conts.sort(GroupNodeOrder);
  StackControls(conts);
  // make sure we update the sizes of the controls so any follow bottom edge controls get resized correctly.
  // we don't have to update the whole screen, just all of the controls that are part of the parent container.
  updateControlSizePartial(parent);
}
// adds the node to the list of
function AddCurrentNode($node, collisionNodes, left, right, top, height) {
  var box = new Object();
  box.left = left + 25;
  box.right = right - 25;
  box.dontStack = $node.get(0).dontStack;
  box.bottom = top + height;
  collisionNodes.push(box);
}
// Stacks the controls on top of each other
function StackControls(conts) {
  var windowSize = $(document).height();
  var collisionNodes = new Array();
  for (var i = 0; i < conts.length; i++) {
    var left = conts[i].offsetLeft;
    var $node = $(conts[i]);
    var right = left + conts[i].offsetWidth;
    var offsetTop = 0;
    var performStacking =
      !conts[i].dontStack &&
      ($node.attr("dontstack") || "false").toLowerCase() !== "true";
    if (performStacking) {
      var y = DropBox($node, collisionNodes, windowSize, left, right);
      $node.offset({ top: y });
      offsetTop = y;
    } else {
      offsetTop = $node.offset().top;
    }
    var height = conts[i].offsetHeight;
    if (conts[i].getAttribute("isGrid")) {
      var $expandButton = $node.find(".inforExpandButton");
      if ($expandButton.length > 0) {
        if ($expandButton.hasClass("closed")) {
          height = $node.find(".inforFieldSetLabel").height();
        }
      }
    }
    AddCurrentNode($node, collisionNodes, left, right, offsetTop, height);
  }
}
// the idea is to "Drop" the controls in place.  This uses collision detection
// to detect when it is in the right place.  The controls start at the bottom of the page and "drop"
// to the top until it hits the bottom of a box
function DropBox(node, collisionNodes, windowSize, left, right) {
  var hit = false;
  var y = windowSize;
  var lowestControl = 0;
  var collisionBox;
  var yMargin = 4; // as specified here: http://wiki.infor.com:8080/confluence/display/COMMONUI/Workspace+Field+Sets
  if (collisionNodes.length > 0) {
    // Find first possible collision as a starting point
    for (var v in collisionNodes) {
      collisionBox = collisionNodes[v];
      if (collisionBox.bottom > lowestControl) {
        lowestControl = collisionBox.bottom;
      }
    }
    // 25 is added to make sure that we don't overlap because the markup is bad
    y = lowestControl + yMargin + 25;
    while (!hit && y >= 0) {
      for (v in collisionNodes) {
        collisionBox = collisionNodes[v];
        // we have a potential hit...do further checking
        if (collisionBox.bottom + yMargin == y) {
          if (
            (left >= collisionBox.left && left <= collisionBox.right) ||
            (right >= collisionBox.left && right <= collisionBox.right) ||
            (left <= collisionBox.left && right >= collisionBox.right)
          ) {
            hit = !collisionBox.dontStack;
            if (!hit) {
              y = 0;
            }
            break;
          }
        }
      }
      if (!hit) {
        y--;
      }
    }
  }
  if (hit) return y;
  return node.offset().top;
}
//Get the current border bottom width style of the supplied DOM node.  It is also assummed that the ucc
//controls will contain a fully maximized group control and they should also have a default one pixel border subtracted
function getBorderBottomWidth(cont) {
  if (
    cont.currentStyle &&
    !isNaN(parseInt(cont.currentStyle.borderBottomWidth, 10))
  )
    return parseInt(cont.currentStyle.borderBottomWidth, 10);
  else if (cont.getAttribute("isUCC") || cont.getAttribute("isAttachOuter"))
    return 1;
  return 0;
}
//Arrange the grouped controls by their top positions
function GroupNodeOrder(a, b) {
  var aTop = calcAbsolutePixelPosition(a).Y;
  var bTop = calcAbsolutePixelPosition(b).Y;
  if (aTop < bTop) return -1;
  else if (aTop > bTop) return 1;
  else return 0;
}
//Follows the width of the parent control.
function FixLayoutWidth(node, parentNode, force) {
  var w = pageManager.calculateFollowEdgeWidth(node, parentNode);
  if (w > 0) {
    node.style.width = w + "px";
    node.setAttribute("calculatedWidth", w);
  }
  return w;
}
//http://stackoverflow.com/questions/986937/how-can-i-get-the-browsers-scrollbar-sizes
var _scrollBarWidth = -1;
function _getScrollBarWidth() {
  if (_scrollBarWidth == -1) {
    var inner = document.createElement("p");
    inner.style.width = "100%";
    inner.style.height = "200px";
    var outer = document.createElement("div");
    outer.style.position = "absolute";
    outer.style.top = "0px";
    outer.style.left = "0px";
    outer.style.visibility = "hidden";
    outer.style.width = "200px";
    outer.style.height = "150px";
    outer.style.overflow = "hidden";
    outer.appendChild(inner);
    document.body.appendChild(outer);
    var w1 = inner.offsetWidth;
    outer.style.overflow = "scroll";
    var w2 = inner.offsetWidth;
    if (w1 == w2) w2 = outer.clientWidth;
    document.body.removeChild(outer);
    _scrollBarWidth = w1 - w2;
  }
  return _scrollBarWidth;
}
function GetDocumentDim() {
  return {
    width: document.body.clientWidth,
    height: document.body.clientHeight
  };
}
function CalculateFollowEdgeHeight(node, parentNode) {
  var h = 0;
  // if the parent node is not given then we will attempt to find it
  if (!parentNode) {
    parentNode = findParentContainer(node);
  }
  //PC - needs to load within the node's context
  var $node = $(node, node.document);
  var scrollTop =
    document.documentElement.scrollTop == 0
	  ? document.body.scrollTop
	  : document.documentElement.scrollTop;
  if (parentNode == document.body) {
    var dim = GetDocumentDim();
	//Chrome and FF use document.body, IE uses dodument.documenElement
    var scrollBar = 0;
    // calculate if there is going to be a scrollbar and if is then take that into account
    if (
      document.body.scrollWidth == dim.width &&
      node.scrollWidth > dim.width
    ) {
      scrollBar = _getScrollBarWidth();
    }
    h = dim.height - node.offsetTop - scrollBar + scrollTop;
    document.body.setAttribute("calculatedHeight", h);
  } else {
    var positionTop = 0;
    try {
      positionTop = $node.position().top;
    } catch (err) {
      log(err, "error");
    }
    var parent = parentNode.clientHeight;
    h = parent - positionTop;
    
    // the tabset has a top margin of 2px that is not taken into account when it is nested in other controls like a groupbox
    if (node.getAttribute("isTabPane")) {
      h -= 2;
    }
  }
  // the tabset puts a 4px top border around any item that has a inforFieldSet className
  if (
    parentNode.getAttribute("isTabPane") &&
    node.className.indexOf("inforFieldSet") > -1
  ) {
    h -= 4;
  }
  if (node.getAttribute("isTree")) {
    h -= themeDefinition.height.tree;
  }
  // if the offsetParent is not this node's parentNode then that means there is another
  // element inbetween our current node and the parentNode that is effecting our top
  // position.  Take into account the offsetParent's top position also
  if (node.offsetParent && parentNode != node.offsetParent) {
	var parentTop;
	// the if clause is used to add scrollTop value for infoviewers so that infinite scrolling will not happen
	if((node.getAttribute("isTree")) || (node.className == "inforRichTextContainer") || (parentNode != document.body)){
		parentTop = $(node.offsetParent).position().top;
	}
	else{
		parentTop = $(node.offsetParent).position().top + scrollTop;
	}
    h -= parentTop;
    // the height of this extra element could cause an overflow, reset the height
    // to auto to ensure that it is never it too big thereby causing scrollbars
    // this could happen with the following markup:
    // <body>
    // 	   <div style='position:absolute;top:56px;height:100%'>
    //		    <htc:groupbox style='position:relative; top:5px;">
    if (
      node.offsetParent != document.body &&
      node.offsetParent.className != "inforFieldSet" &&
      !node.offsetParent.getAttribute("isGroupBoxContainer")
    ) {
      node.offsetParent.style.height = "";
      node.offsetParent.style.overflow = "visible";
    }
  }
  // if there is a min-height on this control lets take that into account.  Our height can't be less than the min-height
  if (node.style.minHeight && node.style.minHeight !== "") {
    var minHeight = parseInt(node.style.minHeight, 10);
    if (h < minHeight) {
      h = minHeight;
    }
  }
  return h;
}
function FixLayoutHeight(node, parentNode, force) {
  var h = CalculateFollowEdgeHeight(node, parentNode);
  if (h > 0) {
    node.style.height = h + "px";
    node.setAttribute("calculatedHeight", h);
  }
  return h;
}
function _getExpressionTreeNode(list, node) {
  var id = "";
  if (node == document.body) {
    id = "__BODY__";
  } else {
    id = node.id;
  }
  var treeNode = null;
  for (var i = 0; i < list.length; i++) {
    if (list[i].id == id) {
      treeNode = list[i];
      break;
    } else {
      treeNode = _getExpressionTreeNode(list[i].children, node);
      if (treeNode) {
        break;
      }
    }
  }
  return treeNode;
}
function _addExpressionControl(list, node, parent, followsEdge, instance) {
  var treeNode = _getExpressionTreeNode(list, node);
  var parentTreeNode = _getExpressionTreeNode(list, parent);
  if (!parentTreeNode) {
    var id = "";
    if (parent == document.body) {
      id = "__BODY__";
    } else {
      id = parent.id;
    }
    parentTreeNode = {
      id: id,
      control: parent,
      children: [],
      followEdge: false
    };
    var parentOfParent = findParentContainer(parent);
    var nodeToAppendTo = _getExpressionTreeNode(list, parentOfParent);
    if (!nodeToAppendTo) {
      nodeToAppendTo = _addExpressionControl(
        list,
        parent,
        parentOfParent,
        false
      );
    }
    nodeToAppendTo.children.push(parentTreeNode);
    parentTreeNode.parentNode = nodeToAppendTo;
  }
  if (!treeNode) {
    treeNode = {
      id: node.id,
      control: node,
      children: [],
      followEdge: followsEdge,
      parentNode: parentTreeNode,
      instance: instance
    };
    parentTreeNode.children.push(treeNode);
  } else {
    // if the tree node already exists then that means it was added due to the fact that it was the parent of another node
    treeNode.followEdge = followsEdge;
    treeNode.parentNode = parentTreeNode;
    treeNode.control = node;
    treeNode.instance = instance;
  }
  return treeNode;
}
// recalculates the expression control.
function updateExpressionControl(cont, action) {
  if (cont) {
    //find the parent container control
    var parentNode = findParentContainer(cont);
    // if the parent is set to "resize to content" then it does not make any sense
    // for the child to follow the edge of the parent because the edge of the parent
    // depends on the size of the content therefore ignore any follow edge stuff
    // when we have this situation
    if (
      parentNode &&
      (!parentNode.ResizeToContent || parentNode.resizeControlWidth)
    ) {
      var treeNode = _getExpressionTreeNode(expControls, cont);
      if (treeNode && treeNode.parentNode.control != parentNode) {
        var followEdge = false;
        if (cont.resizeControlWidth) {
          setupResizeControlWidthAction(cont, parentNode, action, cont);
          followEdge = true;
        }
        if (cont.resizeControlHeight) {
          setupResizeControlHeightAction(cont, parentNode, action, cont);
          followEdge = true;
        }
        var children = treeNode.children;
        var id = cont.id;
        var index = -1,
          i;
        for (i = 0; i < treeNode.parentNode.children.length; i++) {
          if (treeNode.parentNode.children[i].id == id) {
            index = i;
          }
          if (index > -1) {
            treeNode.parentNode.children.splice(index, 1);
          }
        }
        var newTreeNode = _addExpressionControl(
          expControls,
          cont,
          parentNode,
          followEdge
        );
        for (i = 0; i < children.length; i++) {
          children[i].parentNode = newTreeNode;
        }
        newTreeNode.children = children;
        updateControlSize(true, null, newTreeNode, false);
      }
    }
  }
}
/// Turns off follow right edge
function removeExpressionWidthControl(cont) {
  removeExpressionControl(cont, "right");
}
/// Turns off follow bottom edge
function removeExpressionHeightControl(cont) {
  removeExpressionControl(cont, "bottom");
}
/// Turns off follow right edge
function removeExpressionControl(cont, edge) {
  if (cont) {
    var treeNode = _getExpressionTreeNode(expControls, cont);
    if (treeNode) {
      var followAttribute = "followsRightEdgeOf";
      if (edge == "right") {
        treeNode.control.resizeControlWidth = null;
        followAttribute = "followsRightEdgeOf";
      } else if (edge == "bottom") {
        treeNode.control.resizeControlHeight = null;
        followAttribute = "followsBottomEdgeOf";
      } else {
        log(edge + " is not a valid value for edge", "error");
      }
      treeNode.control.removeAttribute("followsBottomEdgeOf");
      treeNode.followEdge =
        treeNode.control.resizeControlHeight != null ||
        treeNode.control.resizeControlWidth != null;
    }
  }
}
//
//Add a full width control to the expression controls array
//
function addExpressionWidthControl($instance, action, parentNode) {
  var cont = $instance.element ? $instance.element[0] : $instance;
  if (cont) {
    if (!parentNode) {
      //find the parent container control
      parentNode = findParentContainer(cont);
    }
    // if the parent is set to "resize to content" then it does not make any sense
    // for the child to follow the edge of the parent because the edge of the parent
    // depends on the size of the content therefore ignore any follow edge stuff
    // when we have this situation
    if (
      parentNode &&
      (!parentNode.ResizeToContent || parentNode.resizeControlWidth)
    ) {
      setupResizeControlWidthAction(cont, parentNode, action, $instance);
      _addExpressionControl(expControls, cont, parentNode, true, $instance);
      $(function() {
        _setToResizeControls(100);
      });
    }
  }
}
function setupResizeControlWidthAction(cont, parentNode, action, $instance) {
  cont.setAttribute("followsRightEdgeOf", parentNode.id);
  cont.resizeControlWidth = action
    ? function() {
        customResizeControlAction(cont, parentNode, action);
      }
    : function invokeFixLayoutWidth() {
        var w = FixLayoutWidth(cont, parentNode);
        if ($instance.resizeControl) $instance.resizeControl({ width: w });
      };
}
function setupResizeControlHeightAction(cont, parentNode, action, $instance) {
  cont.setAttribute("followsBottomEdgeOf", parentNode.id);
  cont.resizeControlHeight = action
    ? function() {
        customResizeControlAction(cont, parentNode, action);
      }
    : function invokeFixLayoutHeight() {
        var h = FixLayoutHeight(cont, parentNode);
        if ($instance.resizeControl) $instance.resizeControl({ height: h });
      };
}
function customResizeControlAction(cont, parentNode, action) {
  try {
    action(cont, parentNode);
  } catch (err) {
    window.log("customResizeControlAction: " + err, "error");
  }
}
//
//Add a full height control to the expression controls array
//
function addExpressionHeightControl($instance, action, parentNode) {
  var cont = $instance && $instance.element ? $instance.element[0] : $instance;
  if (cont) {
    if (!parentNode) {
      //find the parent container control
      parentNode = findParentContainer(cont);
    }
    // if the parent is set to "resize to content" then it does not make any sense
    // for the child to follow the edge of the parent because the edge of the parent
    // depends on the size of the content therefore ignore any follow edge stuff
    // when we have this situation
    if (
      parentNode &&
      (!parentNode.ResizeToContent || parentNode.resizeControlHeight)
    ) {
      setupResizeControlHeightAction(cont, parentNode, action, $instance);
      _addExpressionControl(expControls, cont, parentNode, true, $instance);
      $(function() {
        _setToResizeControls(100);
      });
    }
  }
}
///////////////////////////
function ie8parentOffset(cont) {
  var parent;
  try {
    parent = cont.parentElement;
    if (parent.tagName == "FORM" || parent.tagName == "BODY") {
      parent = document.body;
    } else {
      while (
        parent &&
        parent.style.position == "" &&
        !parent.getAttribute("isUCC") &&
        !parent.getAttribute("isGroupBoxOuter") &&
        !parent.getAttribute("isTabPane") &&
        !parent.getAttribute("isSplitterDiv") &&
        !parent.getAttribute("isTableLayoutGroup")
      ) {
        if (parent.tagName == "FORM" || parent.tagName == "BODY") {
          return document.body;
        } else {
          parent = parent.parentElement;
        }
      }
    }
  } catch (err) {
    log(err, "error");
    parent = document.body;
  }
  return parent;
}
//find the offset parent in terms of a hansen layout and return
function findParentContainer(cont) {
  cont = ie8parentOffset(cont);
  while (cont) {
    if (
      cont == document.body ||
      cont.getAttribute("isUCC") ||
      cont.getAttribute("isGroupBoxOuter") ||
      cont.getAttribute("isTabPane") ||
      cont.getAttribute("isSplitterDiv") ||
      cont.getAttribute("isTableLayoutGroup") ||
      cont.getAttribute("isSplitterOuter")
    )
      return cont;
    cont = ie8parentOffset(cont);
  }
}
function disposeExpressionList(list) {
  for (var i = 0; i < list.length; i++) {
    var treeNode = list[i];
    disposeExpressionList(treeNode.children);
    if (treeNode.control) {
      treeNode.control.resizeControlWidth = null;
      treeNode.control.resizeControlHeight = null;
    }
    treeNode.control = null;
    treeNode.parentNode = null;
    treeNode.children = null;
    treeNode.instance = null;
    treeNode.parentNode = null;
    //treeNode.followEdge = null;
    list[i] = null;
  }
}
// removes the given control from the expression tree
function removeUpdateControlNode(control) {
  // findUpdateControlNode returns the parent container and returns the array containing the children
  var treeNode = findUpdateControlNode(control);
  if (treeNode) {
    for (var i = 0; i < treeNode.length; i++) {
      // make sure we are removing the right one
      if (treeNode[i] && treeNode[i].control == control) {
        disposeExpressionList([treeNode[i]]);
        // removes the item from the list
        treeNode.splice(i, 1);
        break;
      }
    }
  }
}
// finds the tree node containing the given control in the expControls list
function findUpdateControlNode(control, list) {
  var node = null;
  if (!list) {
    list = expControls;
  }
  // there are times when the list is empty because there are no controls that follow any edge
  if (list) {
    for (var i = 0; i < list.length; i++) {
      var treeNode = list[i];
      if (treeNode) {
        if (treeNode.control == control) {
          node = list;
          break;
        }
        node = findUpdateControlNode(control, treeNode.children);
        if (node) {
          break;
        }
      }
    }
  }
  return node;
}
// only updates part of the view
function updateControlSizePartial(control) {
  var treeNode = findUpdateControlNode(control, expControls);
  updateControlSize(true, null, treeNode, false);
}
//Method for event handler on document body
//all group controls sizes are recalculated
function updateControlSize(force, vid, list, skipListenerNotification) {
  _controlSizeUpdateQueued = false;
  if (!list) {
    list = expControls;
  }
  // there are times when the list is empty because there are no controls that follow any edge
  if (list) {
    for (var i = 0; i < list.length; i++) {
      var treeNode = list[i];
      if (treeNode.followEdge && treeNode.control) {
        if (treeNode.control.resizeControlWidth) {
          treeNode.control.resizeControlWidth();
        }
        if (treeNode.control.resizeControlHeight) {
          treeNode.control.resizeControlHeight();
        }
      }
      if (treeNode.children && treeNode.children.length > 0) {
        updateControlSize(force, vid, treeNode.children, true);
      }
    }
    if (!skipListenerNotification) {
      SystemEvents("updateControlSize", vid).trigger();
    }
  }
}
